import React from "react";
import PropTypes from "prop-types";
import { InputText, Label } from "../../../../components/Inputs";
import {
  SiSTelekomPermission,
  getJarvisPermissionLabel,
  normalizeJarvisPermission,
} from "../../../Worker/components/Utils";

function JarvisConnectionTaskForm({
  forwardedRef,
  className = "",
  model = {
    id: 0,
    parentCompanyName: "",
    vodafoneAccountUsername: "",
    permissions: "",
    externalEmail: "",
    ngumUserId: "",
  },
  // isDeleting = false,
}) {
  const validate = React.useCallback(() => model, [model]);
  const getModel = React.useCallback(() => validate(), [validate]);
  React.useImperativeHandle(forwardedRef, () => ({
    getModel,
  }));

  return (
    <div className={className}>
      <div className="pad-top- form-group-item">
        <Label>{`Vertragspartner`}</Label>
        <InputText
          className="w3-block w3-border w3-round pad"
          value={model.parentCompanyName}
          readonly
        />
      </div>
      <div className="pad-top form-group-item">
        <Label>{`Kennung`}</Label>
        <InputText
          className="w3-block w3-border w3-round pad"
          value={model.vodafoneAccountUsername || ""}
          readonly
        />
      </div>
      <div className="pad-top form-group-item">
        <Label>{`nGUM User ID`}</Label>
        <InputText
          className="w3-block w3-border w3-round pad"
          value={model.ngumUserId || ""}
          readonly
        />
      </div>
      <div className="pad-top form-group-item">
        <Label>{`Rechte`}</Label>
        <InputText
          className="w3-block w3-border w3-round pad"
          value={getJarvisPermissionLabel(model.permissions)}
          readonly
        />
      </div>
      {normalizeJarvisPermission(model.permissions) ===
        normalizeJarvisPermission(SiSTelekomPermission) && (
        <div className={`pad-top form-group-item`}>
          <Label htmlFor="username">{`Externe E-Mail Adresse*`}</Label>
          <InputText
            id="externalEmail"
            className="w3-block w3-border w3-round pad"
            value={model.externalEmail}
            readonly
          />
        </div>
      )}
    </div>
  );
}

JarvisConnectionTaskForm.propTypes = {
  className: PropTypes.string,
  model: PropTypes.shape({
    id: PropTypes.number,
    parentCompanyName: PropTypes.string,
    vodafoneAccountUsername: PropTypes.string,
    permissions: PropTypes.string,
    externalEmail: PropTypes.string,
  }),
  isDeleting: PropTypes.bool,
};

export default React.forwardRef((props, ref) => (
  <JarvisConnectionTaskForm {...props} forwardedRef={ref} />
));
